// extracted by mini-css-extract-plugin
export default {"viewBox":"AdminHelp_viewBox__MtNYV"};